// @core/stores/user/UserInternalStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { userApi } from '@core/api';
import type {
  CheckUserExistsRequest,
  CheckUserExistsResponse,
  CreateUserInternalRequest,
  UserResponse,
} from '@core/types/user';

class UserInternalStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Check if user exists
   */
  async CheckUserExists(data: CheckUserExistsRequest): Promise<CheckUserExistsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userApi.CheckUserExists(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Create user (internal)
   */
  async CreateUserInternal(data: CreateUserInternalRequest): Promise<UserResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userApi.CreateUserInternal(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const userInternalStore = new UserInternalStore();
